import axios from '@/utils/axiosRequest'
// 登录接口
export const Loginnterface = (data) => {
  return axios.request({
    url: '/mk/wllogin',
    method: 'POST',
    data
  })
}
// 验证码
export const Verificationcode = (data) => {
  return axios.request({
    url: '/mk/getnote',
    method: 'POST',
    data
  })
}
// 注册
export const registered = (data) => {
  return axios.request({
    url: '/mk/wladd',
    method: 'POST',
    data
  })
}
// 轮播图
export const Shufflingfigure = (data) => {
  return axios.request({
    url: '/mk/photo',
    method: 'POST',
    data
  })
}
// token 验证
export const Tokenauthentication = (data) => {
  return axios.request({
    url: '/mk/jwttoken',
    method: 'POST',
    data
  })
}
// 课程合作接口
export const inskcz = (data) => {
  return axios.request({
    url: '/mk/inskchz',
    method: 'POST',
    data
  })
}
// 通知 新闻
export const selpublic = (data) => {
  return axios.request({
    url: '/mk/selpublic',
    method: 'POST',
    data
  })
}
// 个人信息
export const upduser = (data) => {
  return axios.request({
    url: '/mk/upduser',
    method: 'POST',
    data
  })
}
// 修改密码获取验证码
export const finnback = (data) => {
  return axios.request({
    url: '/mk/finn_back',
    method: 'POST',
    data
  })
}
// 修改密码接口
export const finnbnoteverifyack = (data) => {
  return axios.request({
    url: '/mk/noteverify',
    method: 'POST',
    data
  })
}
// 修改密码接口
export const thepassword = (data) => {
  return axios.request({
    url: '/mk/upduserpassword',
    method: 'POST',
    data
  })
}
// 推荐十条信息
export const selpublictj = (data) => {
  return axios.request({
    url: '/mk/selpublictj',
    method: 'POST',
    data
  })
}

// 详细信息
export const seluser = (data) => {
  return axios.request({
    url: '/mk/seluser',
    method: 'POST',
    data
  })
}

// 课程列表
export const selitem = (data) => {
  return axios.request({
    url: '/mk/selitem',
    method: 'POST',
    data
  })
}

// 老师相关课程
export const sellsitem = (data) => {
  return axios.request({
    url: '/mk/sellsitem',
    method: 'POST',
    data
  })
}
// 学员评论
export const lnsleaves = (data) => {
  return axios.request({
    url: '/mk/insleaves',
    method: 'POST',
    data
  })
}

// 评论列表
export const selleaves = (data) => {
  return axios.request({
    url: '/mk/selleaves',
    method: 'POST',
    data
  })
}

// 回复评论列表
export const selhfleaves = (data) => {
  return axios.request({
    url: '/mk/selhfleaves',
    method: 'POST',
    data
  })
}

// 评分
export const insrate = (data) => {
  return axios.request({
    url: '/mk/insrate',
    method: 'POST',
    data
  })
}

// 课程评分
export const inshfleaves = (data) => {
  return axios.request({
    url: '/mk/inshfleaves',
    method: 'POST',
    data
  })
}
// 用户获取该课程的评分
export const selrate = (data) => {
  return axios.request({
    url: '/mk/selrate',
    method: 'POST',
    data
  })
}

// 评论撤回功能
export const delhfleaves = (data) => {
  return axios.request({
    url: '/mk/delhfleaves',
    method: 'POST',
    data
  })
}

// 删除楼主留言
export const delleavea = (data) => {
  return axios.request({
    url: '/mk/delleaves',
    method: 'POST',
    data
  })
}

// 我的评分列表

export const selratelist = (data) => {
  return axios.request({
    url: '/mk/selratelist',
    method: 'POST',
    data
  })
}
// 删除评分
export const delrate = (data) => {
  return axios.request({
    url: '/mk/delrate',
    method: 'POST',
    data
  })
}
// 用户收藏
export const inscollect = (data) => {
  return axios.request({
    url: '/mk/inscollect',
    method: 'POST',
    data
  })
}
// 用户收藏状态selcollect
export const selcollect = (data) => {
  return axios.request({
    url: '/mk/selcollect',
    method: 'POST',
    data
  })
}

// ///////////////我的收藏
// 列表
export const selcollectlist = (data) => {
  return axios.request({
    url: '/mk/selcollectlist',
    method: 'POST',
    data
  })
}
// // 收藏删除
export const delcollect = (data) => {
  return axios.request({
    url: '/mk/delcollect',
    method: 'POST',
    data
  })
}
/// //////学习记录
// 添加学习记录
export const insreodrd = (data) => {
  return axios.request({
    url: '/mk/insreodrd',
    method: 'POST',
    data
  })
}
// 列表
export const selrecordlist = (data) => {
  return axios.request({
    url: '/mk/selrecordlist',
    method: 'POST',
    data
  })
}

// 用户删除学习记录
export const delrecord = (data) => {
  return axios.request({
    url: '/mk/delrecord',
    method: 'POST',
    data
  })
}

// 首页
export const selitemtj = (data) => {
  return axios.request({
    url: '/mk/selitemtj',
    method: 'POST',
    data
  })
}
// 类别列表
export const selsort = (data) => {
  return axios.request({
    url: '/mk/selsort',
    method: 'POST',
    data
  })
}

// 猜你喜欢接口
export const selitemcnxx = (data) => {
  return axios.request({
    url: '/mk/selitemcnxx',
    method: 'POST',
    data
  })
}

// 老师信息
export const seljsxx = (data) => {
  return axios.request({
    url: '/mk/seljsxx',
    method: 'POST',
    data
  })
}
// 查询页
export const selmhcxitem = (data) => {
  return axios.request({
    url: '/mk/selmhcxitem',
    method: 'POST',
    data
  })
}
/// ////////////////////////////////
// 素材列表
export const selmaterial = (data) => {
  return axios.request({
    url: '/mk/selmaterial',
    method: 'POST',
    data
  })
}
// 素材评价

export const insratesc = (data) => {
  return axios.request({
    url: '/mk/insratesc',
    method: 'POST',
    data
  })
}
// 我的评分
export const selratesc = (data) => {
  return axios.request({
    url: '/mk/selratesc',
    method: 'POST',
    data
  })
}
// 素材评分列表
export const selratesclist = (data) => {
  return axios.request({
    url: '/mk/selratesclist',
    method: 'POST',
    data
  })
}
// 删除素材评分
export const delscrate = (data) => {
  return axios.request({
    url: '/mk/delscrate',
    method: 'POST',
    data
  })
}

// 素材收藏/
export const inssccollect = (data) => {
  return axios.request({
    url: '/mk/inssccollect',
    method: 'POST',
    data
  })
}
// 获取素材收藏状态
export const selsccollect = (data) => {
  return axios.request({
    url: '/mk/selsccollect',
    method: 'POST',
    data
  })
}
// 收藏列表
export const selsccollectlist = (data) => {
  return axios.request({
    url: '/mk/selsccollectlist',
    method: 'POST',
    data
  })
}
// 收藏列表
export const delsccollect = (data) => {
  return axios.request({
    url: '/mk/delsccollect',
    method: 'POST',
    data
  })
}
// 素材浏览
export const selscrecordlist = (data) => {
  return axios.request({
    url: '/mk/selscrecordlist',
    method: 'POST',
    data
  })
}
// 素材浏览删除
export const delscrecord = (data) => {
  return axios.request({
    url: '/mk/delscrecord',
    method: 'POST',
    data
  })
}
// 素材上传
export const insmaterial = (data) => {
  return axios.request({
    url: '/mk/insmaterial',
    method: 'POST',
    data
  })
}
// 素材列表
export const updmaterial = (data) => {
  return axios.request({
    url: '/mk/updmaterial',
    method: 'POST',
    data
  })
}
// 素材状态修该
export const updmaterialsp = (data) => {
  return axios.request({
    url: '/mk/updmaterialsp',
    method: 'POST',
    data
  })
}
// 素材删除
export const delmaterial = (data) => {
  return axios.request({
    url: '/mk/delmaterial',
    method: 'POST',
    data
  })
}

// 用户素材页
export const selusersc = (data) => {
  return axios.request({
    url: '/mk/selusersc',
    method: 'POST',
    data
  })
}
// 热门搜错
export const selhotsearch = (data) => {
  return axios.request({
    url: '/mk/selhotsearch',
    method: 'POST',
    data
  })
}

// 素材搜索
export const selscname = (data) => {
  return axios.request({
    url: '/mk/selscname',
    method: 'POST',
    data
  })
}

// 浏览量 课程
export const updll = (data) => {
  return axios.request({
    url: '/mk/updll',
    method: 'POST',
    data
  })
}
// 申请成为讲师
export const upduserzt = (data) => {
  return axios.request({
    url: '/mk/upduserzt',
    method: 'POST',
    data
  })
}
// 课件查询列表
export const seluseritem = (data) => {
  return axios.request({
    url: '/mk/seluseritem',
    method: 'POST',
    data
  })
}

// 课件添加
export const insitme = (data) => {
  return axios.request({
    url: '/mk/insitme',
    method: 'POST',
    data
  })
}
// 富文本图片接口
export const Richtextimage = data => {
  return axios.request({
    url: '/mk/insertdate',
    method: 'POST',
    data
  })
}
// 删除课程
export const delitem = data => {
  return axios.request({
    url: '/mk/delitem',
    method: 'POST',
    data
  })
}

// 编辑课程
export const upditem = data => {
  return axios.request({
    url: '/mk/upditem',
    method: 'POST',
    data
  })
}

// 课程改变状态
export const upditemsp = (data) =>{
  return axios.request({
      url: '/mk/upditemsp',
      method: 'POST',
      data
    })
}

// 申请成为医生
export const insdoctor = (data) =>{
  return axios.request({
      url: '/muke/insdoctor',
      method: 'POST',
      data
    })
}
// 查询
export const seldoctor = (data) =>{
  return axios.request({
      url: '/muke/seldoctor',
      method: 'POST',
      data
    })
}
// 修改
export const updoctor = (data) =>{
  return axios.request({
      url: '/muke/upddoctor',
      method: 'POST',
      data
    })
}

// 任务列表
export const seltask = (data) => {
  return axios.request({
    url: '/muke/seltask',
    method: 'POST',
    data
  })
}
// 编辑任务
export const updtask = (data) => {
  return axios.request({
    url: '/muke/updtask',
    method: 'POST',
    data
  })
}
// cha寻分类
export const selsortMu = (data) => {
  return axios.request({
    url: '/muke/selsort',
    method: 'POST',
    data
  })
}
// 查询助手
export const selaide = (data) => {
  return axios.request({
    url: '/muke/selaide',
    method: 'POST',
    data
  })
}
// 上传科普
export const insknow = (data) => {
  return axios.request({
    url: '/muke/insknow',
    method: 'POST',
    data
  })
}

// 查询科普
export const selknow = (data) => {
  return axios.request({
    url: '/muke/selknow',
    method: 'POST',
    data
  })
}
// 修改科普
export const updknow = (data) => {
  return axios.request({
    url: '/muke/updknow',
    method: 'POST',
    data
  })
}
// 删除科普
export const delknow = (data) => {
  return axios.request({
    url: '/muke/delknow',
    method: 'POST',
    data
  })
}
// 接取任务
export const instaskuser = (data) => {
  return axios.request({
    url: '/muke/instaskuser',
    method: 'POST',
    data
  })
}
// 查询任务
export const seltaskuser = (data) => {
  return axios.request({
    url: '/muke/seltaskuser',
    method: 'POST',
    data
  })
}
// // 编辑任务
// export const updtaskuser = (data) => {
//   return axios.request({
//     url: '/muke/updtaskuser',
//     method: 'POST',
//     data
//   })
// }
// 删除任务
export const deltaskuser = (data) => {
  return axios.request({
    url: '/muke/deltaskuser',
    method: 'POST',
    data
  })
}
// 修改任务
export const updatetaskuser = (data) => {
  return axios.request({
    url: '/muke/updatetaskuser',
    method: 'POST',
    data
  })
}
// 评委评分
export const insscore = (data) => {
  return axios.request({
    url: '/muke/insscore',
    method: 'POST',
    data
  })
}
// 评委评分
export const selscore = (data) => {
  return axios.request({
    url: '/muke/selscore',
    method: 'POST',
    data
  })
}
// 新增收藏 点赞 浏览
export const insknownumber = (data) => {
  return axios.request({
    url: '/muke/insknownumber',
    method: 'POST',
    data
  })
}
// 查询收藏 点赞 浏览
export const selknownumber = (data) => {
  return axios.request({
    url: '/muke/selknownumber',
    method: 'POST',
    data
  })
}
// 删除收藏 点赞 浏览
export const delknownumber = (data) => {
  return axios.request({
    url: '/muke/delknownumber',
    method: 'POST',
    data
  })
}

// 新增知识科普留言
export const insremark = (data) => {
  return axios.request({
    url: '/muke/insremark',
    method: 'POST',
    data
  })
}
// 查询知识科普留言
export const selremark = (data) => {
  return axios.request({
    url: '/muke/selremark',
    method: 'POST',
    data
  })
}
// 删除知识科普留言
export const delremark = (data) => {
  return axios.request({
    url: '/muke/delremark',
    method: 'POST',
    data
  })
}
// 新增知识科普留言hf
export const insremarkhf = (data) => {
  return axios.request({
    url: '/muke/insremarkhf',
    method: 'POST',
    data
  })
}
// 查询知识科普留言hf
export const selremarkhf = (data) => {
  return axios.request({
    url: '/muke/selremarkhf',
    method: 'POST',
    data
  })
}
// 删除知识科普留言hf
export const delremarkhf = (data) => {
  return axios.request({
    url: '/muke/delremarkhf',
    method: 'POST',
    data
  })
}
